import React from 'react';
import { Flex, Heading, Text, Button, Image } from 'rebass';
import { startAddCandidateSubmit, resolveAddCandidateSubmit } from 'modules/Candidates/actions';
import Form from 'components/Form';
import Field from 'components/Field';
import ErrorMessage from 'components/ErrorMessage';
import paperclipIcon from 'assets/icons/paperclip.png';
import deleteAttachmentsIcon from 'assets/icons/deleteAttachments.png';

interface AddCandidateFormProps {
  jobPostId: number;
}

const AddCandidateForm: React.FC<AddCandidateFormProps> = ({ jobPostId }): JSX.Element => {
  return (
    <Form
      startSubmitAction={startAddCandidateSubmit().type}
      resolveSubmitAction={resolveAddCandidateSubmit().type}
      setPayload={(action: object, payload: any) => ({
        ...action,
        payload: {
          ...payload,
          jobPostId,
        },
      })}
    >
      {(props: any) => {
        const { form, values, submitting, submitErrors } = props;
        return (
          <Flex flexDirection="column" alignItems="center" py={7}>
            {submitErrors && <ErrorMessage>{submitErrors.data.error.message}</ErrorMessage>}
            <Heading width="100%" fontSize={['36px']} fontWeight={6} mb={7}>
              Add a candidate
            </Heading>
            <Flex width="100%" justifyContent="space-between" mb={5}>
              <Flex flexDirection="column">
                <Heading fontSize={['20px']} fontWeight={6} mb={4}>
                  Personal Info
                </Heading>
                <Field
                  name="firstName"
                  label="First Name"
                  inputType="text"
                  width="350px"
                  required
                  labelAsterisk
                />
                <Field name="lastName" label="Last Name" width="350px" required labelAsterisk />
                <Field
                  name="email"
                  label="Work Email"
                  inputType="email"
                  width="350px"
                  required
                  labelAsterisk
                />
                <Field
                  name="phoneNumber"
                  label="Contact Number"
                  width="350px"
                  required
                  labelAsterisk
                />
                <Field name="city" label="City" width="350px" required labelAsterisk />
              </Flex>
              <Flex flexDirection="column">
                <Heading fontSize={['20px']} fontWeight={6} mb={4}>
                  Skills
                </Heading>
                <Field
                  name="summary"
                  label="Summary"
                  inputType="textarea"
                  width="350px"
                  height="102px"
                  required
                  labelAsterisk
                />
                <Field
                  name="firstSkill"
                  label="Indicate your top three skills"
                  width="350px"
                  required
                  labelAsterisk
                />
                <Field name="secondSkill" width="350px" required />
                <Field name="thirdSkill" width="350px" required />
                <Field name="salary" label="Desired salary:" inputType="number" width="205px" />
              </Flex>
              <Flex flexDirection="column">
                <Heading fontSize={['20px']} fontWeight={6} mb={4}>
                  Links
                </Heading>
                <Field name="linkedInUrl" label="LinkedIn URL" />
                <Field name="twitterUrl" label="Twitter URL" />
                <Field name="gitHubUrl" label="GitHub URL" />
                <Field name="website" label="Website" />
                <Field name="portfolioUrl" label="Portfolio URL" />
              </Flex>
            </Flex>
            <Flex width="100%">
              <Flex width="100%" justifyContent="space-between" css="max-width: 755px;">
                <Flex flexDirection="column">
                  <Heading fontSize={['20px']} fontWeight={6} mb={4}>
                    Notes
                  </Heading>
                  <Field name="notes" inputType="textarea" width="350px" height="250px" />
                </Flex>
                <Flex width="100%" flexDirection="column" css="max-width: 350px;">
                  <Heading fontSize={['20px']} fontWeight={6} mb={4}>
                    Attachments
                  </Heading>
                  {values.cvUrl ? (
                    <Flex alignItems="center">
                      <Image src={paperclipIcon} mr={1} />
                      <Text>{values.cvUrl.name}</Text>
                      <Image
                        src={deleteAttachmentsIcon}
                        ml={1}
                        onClick={() => {
                          form.change('cvUrl', undefined);
                        }}
                        css="cursor: pointer;"
                      />
                    </Flex>
                  ) : (
                    <Flex alignItems="center">
                      <Text fontSize="18px" fontWeight={5} mr={3}>
                        Upload resume
                      </Text>
                      <Field
                        name="cvUrl"
                        inputType="file"
                        fileInputText="Upload"
                        changeHandler={form.change}
                      />
                    </Flex>
                  )}
                </Flex>
              </Flex>
            </Flex>
            <Flex width="100%" mt={2}>
              <Button type="submit" variant={submitting ? 'disabled' : 'primary'}>
                Submit
              </Button>
            </Flex>
          </Flex>
        );
      }}
    </Form>
  );
};

export default AddCandidateForm;
